import { useState } from 'react';
import groupBy from 'lodash/groupBy';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// import InputAdornment from '@mui/material/InputAdornment';
// import SearchIcon from '@mui/icons-material/Search';

import CustomBox from '../common/CustomBox';
import CustomSubheader from './CustomSubheader';
import ProviderCustomList from './ProviderCustomList';

const ProviderWhatITreat = props => {
  const { provider } = props;
  // eslint-disable-next-line no-unused-vars
  const [searchPrompt, setSearchPrompt] = useState(null);
  if (!provider.whatITreat || !provider.whatITreat.length) return <></>;
  const searchRegex = new RegExp(searchPrompt, 'ig');
  const inScopeIssues = provider.whatITreat.filter(
    i => searchPrompt ? searchRegex.test(i.title || '') : true
  );
  const categories = groupBy(inScopeIssues, i => i.subcategory);
  return (
    <CustomBox borderless paddingBottom='8px !important'>
      <CustomSubheader>
        What I Treat
      </CustomSubheader>
      <Typography variant='normal' color='text.light' lineHeight='normal' component='p' letterSpacing='0.5px'>
        {'(Including but not limited to)'}
      </Typography>
      <Box>
        {/* <CustomTextField
          id='searchWhatITreatInput'
          label=''
          placeholder='Search your symptoms'
          type='text'
          InputProps={{
            startAdornment: <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>,
          }}
          onChange={e => setSearchPrompt(e.target.value)}
          fullWidth
          style={{backgroundColor: 'white'}}
          sx={{marginTop: '1em'}}
        /> */}
        <Box paddingTop='0.65rem'>
          {Object.keys(categories).map((k, i) =>
            <ProviderCustomList
              key={i}
              title={k.replace('_', ' ')}
              items={categories[k].map(issue => issue.title)}
              borderBottomList
            />
          )}
        </Box>
      </Box>
    </CustomBox>
  );
};

export default ProviderWhatITreat;
